import { FontFamily } from '@starrez/starryui/dist/Theme';
import { scheme } from '@starryui10/theme/scheme';
import styled from 'styled-components';

interface IContainerButtonProps {
    Size: number;
    IsFullSize: boolean;
    Show: boolean;
}

const buildConditionalStyle = (show: boolean, isFullSize: boolean, size: number) => {
    if (!show) {
        return { opacity: 0 };
    }

    if (isFullSize) {
        return { height: '100%' };
    }

    return {
        borderBottomLeftRadius: `${size * 2}px`,
        borderBottomRightRadius: `${size * 2}px`,
        height: '50%',
        opacity: 0.9,
    };
};

export const ContainerDiv = styled.div<IContainerButtonProps>`
    ${scheme.Blue.Dark}
    font-family: ${FontFamily};
    ${(props) => buildConditionalStyle(props.Show, props.IsFullSize, props.Size)}
    position: absolute;
    bottom: 0;
    width: 100%;
    font-size: 10px !important;
    font-weight: bold;
    cursor: pointer;
`;

interface IContentDivProps {
    ActualSize: number;
    IsLargest: boolean;
    IsFullSize: boolean;
}

export const ContentDiv = styled.div<IContentDivProps>`
    display: grid;
    justify-items: center;
    align-content: ${(props) => (props.IsFullSize || !props.IsLargest ? 'center' : 'start')};
    height: ${(props) => (props.IsFullSize || props.IsLargest ? '100%' : '75%')};
`;
